import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'cap-functionbar-list',
  template: ` <ng-content></ng-content> `
})
export class FunctionbarListComponent {
  @Input()
  align: 'left' | 'right' = 'left';

  @HostBinding('class') class = 'functionbarlist navbar-nav';

  @HostBinding('class.ms-auto') get alignment(): boolean {
    return this.align === 'right';
  }
}
